import React from 'react';
import LegalPage, { Section, SubSection } from './LegalPage';

export default function PrivacyPage() {
  return (
    <LegalPage
      title="Privacy Policy"
      subtitle="Informativa ai sensi dell'art. 13 del Regolamento UE 2016/679 (GDPR) e del D.Lgs. 196/2003 come modificato dal D.Lgs. 101/2018."
      lastUpdate="21 giugno 2026"
    >
      <p>
        La presente informativa descrive come vengono trattati i dati personali raccolti tramite questo
        sito e nell'ambito dell'attività clinica del Dr. Michele Balducci.
      </p>

      <Section title="1. Titolare del trattamento">
        <p>
          Titolare del trattamento è <strong>Dr. Michele Balducci</strong>, psicologo iscritto all'Ordine
          degli Psicologi del Lazio n. 21747 — P.IVA 13906801009. Eroga consulenza psicologica esclusivamente online.
        </p>
        <p>Email: <a className="text-forest underline" href="mailto:m.balducci1987@gmail.com">m.balducci1987@gmail.com</a> · Telefono / WhatsApp: <a className="text-forest underline" href="tel:+393472208426">+39 347 2208426</a></p>
      </Section>

      <Section title="2. Categorie di dati trattati">
        <SubSection title="Dati di contatto (prenotazione)">
          <p>Nome e cognome, numero di telefono, indirizzo email, eventuali note libere inserite dall'utente nel modulo di prenotazione.</p>
        </SubSection>
        <SubSection title="Dati sanitari (durante la relazione terapeutica)">
          <p>
            Nel corso del percorso clinico vengono raccolte informazioni di natura sanitaria, psicologica e
            anamnestica, trattate <strong>esclusivamente</strong> nell'ambito del segreto professionale di cui all'art. 22
            del Codice Deontologico degli Psicologi Italiani.
          </p>
        </SubSection>
        <SubSection title="Dati tecnici di navigazione">
          <p>
            Il sito non utilizza cookie di profilazione né strumenti di analytics di terze parti.
            Il server può registrare in forma temporanea l'indirizzo IP e l'orario di accesso per finalità di sicurezza.
          </p>
        </SubSection>
      </Section>

      <Section title="3. Finalità e base giuridica">
        <ul className="list-disc pl-5 space-y-1.5">
          <li><strong>Gestione delle prenotazioni</strong> e contatto preliminare — base giuridica: esecuzione di misure precontrattuali su richiesta dell'interessato (art. 6 §1 lett. b GDPR).</li>
          <li><strong>Erogazione della prestazione professionale</strong> di psicologia/psicoterapia — base giuridica: art. 9 §2 lett. h GDPR (finalità di cura) e consenso esplicito raccolto al primo colloquio.</li>
          <li><strong>Adempimenti fiscali e amministrativi</strong> — base giuridica: obbligo di legge (art. 6 §1 lett. c GDPR).</li>
          <li><strong>Sicurezza informatica e log tecnici</strong> — base giuridica: legittimo interesse del titolare (art. 6 §1 lett. f GDPR).</li>
        </ul>
      </Section>

      <Section title="4. Modalità di trattamento e tempi di conservazione">
        <p>
          I dati sono trattati con strumenti elettronici protetti da credenziali individuali e da misure tecniche
          adeguate (cifratura in transito, accesso ristretto, backup periodici).
        </p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>Dati di prenotazione: conservati fino a 24 mesi dall'ultimo contatto, salvo proseguimento del percorso clinico.</li>
          <li>Cartella clinica e dati sanitari: conservati per <strong>10 anni</strong> dalla conclusione del percorso, in conformità alla normativa deontologica.</li>
          <li>Documentazione fiscale (fatture): conservata 10 anni come previsto dal codice civile.</li>
          <li>Log tecnici di sicurezza: conservati massimo 12 mesi.</li>
        </ul>
      </Section>

      <Section title="5. Destinatari dei dati">
        <p>
          I dati non sono comunicati a terzi né diffusi, salvo i casi previsti dalla legge (es. richiesta dell'Autorità Giudiziaria)
          o quando strettamente necessario per l'erogazione del servizio (es. fornitore del software gestionale, consulente fiscale,
          hosting provider del sito), che agiscono in qualità di Responsabili del trattamento.
        </p>
      </Section>

      <Section title="6. Trasferimento extra-UE">
        <p>
          I dati sono trattati all'interno dell'Unione Europea. Qualora vengano utilizzati servizi che comportano
          trasferimento extra-UE (es. videoconsulto), saranno scelti fornitori con garanzie adeguate (decisioni di adeguatezza
          della Commissione UE o clausole contrattuali standard).
        </p>
      </Section>

      <Section title="7. Diritti dell'interessato">
        <p>In ogni momento puoi esercitare i seguenti diritti previsti dagli artt. 15-22 GDPR:</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>Accesso ai tuoi dati personali</li>
          <li>Rettifica o aggiornamento dei dati inesatti</li>
          <li>Cancellazione (nei limiti degli obblighi di conservazione clinica e fiscale)</li>
          <li>Limitazione del trattamento</li>
          <li>Portabilità dei dati</li>
          <li>Opposizione al trattamento basato sul legittimo interesse</li>
          <li>Revoca del consenso prestato (con effetto non retroattivo)</li>
        </ul>
        <p>
          Per esercitarli scrivi a{' '}
          <a className="text-forest underline" href="mailto:m.balducci1987@gmail.com">m.balducci1987@gmail.com</a>.
          Hai inoltre diritto di proporre reclamo al Garante per la protezione dei dati personali (<a className="text-forest underline" href="https://www.garanteprivacy.it" target="_blank" rel="noreferrer">garanteprivacy.it</a>).
        </p>
      </Section>

      <Section title="8. Modifiche all'informativa">
        <p>
          La presente informativa può essere aggiornata in qualsiasi momento; la versione vigente sarà sempre
          disponibile in questa pagina, con indicazione della data di ultimo aggiornamento.
        </p>
      </Section>
    </LegalPage>
  );
}
